// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { ActionsState } from '../_reducers/action.reducers';
import { each } from 'lodash-es';
import { ActionModel } from '../_models/action.model';

export const selectActionsState = createFeatureSelector<ActionsState>('actions');

export const selectActionById = (actionId: number) =>
  createSelector(selectActionsState, (actionsState) => actionsState.entities[actionId]);

export const selectActionsPageLoading = createSelector(selectActionsState, (actionsState) => {
  return actionsState.listLoading;
});

export const selectActionsActionLoading = createSelector(
  selectActionsState,
  (actionsState) => actionsState.actionsloading,
);

export const selectLastCreatedActionId = createSelector(
  selectActionsState,
  (actionsState) => actionsState.lastCreatedActionId,
);

export const selectLastCreatedAction = createSelector(
  selectActionsState,
  (actionsState) => actionsState.lastCreatedAction,
);

export const selectActionsPageLastQuery = createSelector(
  selectActionsState,
  (actionsState) => actionsState.lastQuery,
);
export const selectActionError = createSelector(
  selectActionsState,
  (actionsState) => actionsState.error,
);
export const selectActionLatestSuccessfullAction = createSelector(
  selectActionsState,
  (actionsState) => actionsState.latestSuccessfullAction,
);
export const selectActionsInStore = createSelector(selectActionsState, (actionsState) => {
  const items: ActionModel[] = [];
  each(actionsState.ids, (ele) => {
    const index: number = +ele;
    items.push(actionsState.entities[index]);
  });
  return new QueryResultsModel(items, actionsState.totalCount);
});

export const selectActionsShowInitWaitingMessage = createSelector(
  selectActionsState,
  (actionsState) => actionsState.showInitWaitingMessage,
);

export const selectHasActionsInStore = createSelector(selectActionsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
